import { queryOptions, useQuery } from "@tanstack/react-query";
import { parseResponse } from "lib/fetch";
import { getForeignLanguagesRequest } from "lib/api/reference/foreignLanguages";
import type { ForeignLanguagesInterface } from "types/reference";

export const foreignLanguagesReferenceKeys = {
    all: ["reference", "foreign-languages"] as const,
    list: (languageCode: string) => [...foreignLanguagesReferenceKeys.all, "list", languageCode] as const,
};

export const fetchForeignLanguages = (languageCode: string) =>
    parseResponse<Array<ForeignLanguagesInterface>>(getForeignLanguagesRequest(languageCode));

export const foreignLanguagesReferenceQueryOptions = (languageCode: string) =>
    queryOptions<Array<ForeignLanguagesInterface>>({
        queryKey: foreignLanguagesReferenceKeys.list(languageCode || "__missing__"),
        queryFn: () => fetchForeignLanguages(languageCode),
        enabled: Boolean(languageCode),
    });

export const useForeignLanguages = (languageCode: string) =>
    useQuery(foreignLanguagesReferenceQueryOptions(languageCode));
